import {ITranslationService} from "./translation.service.interface";

export class TextTranslation {
    constructor(private readonly translationService: ITranslationService,
                public readonly translationKey: string,
                private readonly _parameters?: any) {
    }

    get translation(): string {
        return this.translationService.translate(this.translationKey, this._parameters);
    }

}